<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">
        <el-button icon="el-icon-back" size="mini" style="font-size: 20px; color: #000;" type="text" @click="goback"></el-button>
        <el-divider direction="vertical"></el-divider>
        云端录像 {{ $route.params.type === '0' ? '(全存)' : '(动存)' }}
      </div>
      <div class="page-header-btn">
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
          <el-form-item style="margin: 0;padding: 0;" label="日期范围" prop="field101">
            <el-date-picker size="mini"
              type="datetimerange"
              v-model="queryParams.field101"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :style="{width: '100%'}"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="至"
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item style="margin: 0;padding: 0;">
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table v-loading="loading" :data="logList" @cell-dblclick="copyText" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column label="国标编号" align="center" prop="deviceId"/>
      <el-table-column label="通道编号" align="center" prop="channelId"/>
      <el-table-column label="开始时间" align="center" prop="startDate">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.startDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center" prop="endDate">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.endDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="文件大小/MB" align="center" prop="size" width="180">
        <template slot-scope="scope">
          <span>{{ Math.ceil(scope.row.size / 1048576) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="260">
        <template slot-scope="scope">
          <el-button title="在外部播放器中播放" size="mini" icon="el-icon-video-play" type="primary" @click="playRecord(scope.row, 0)">播放器</el-button>
          <el-button title="在浏览器中播放" size="mini" icon="el-icon-video-play" type="success" @click="playRecord(scope.row, 1)">浏览器</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="queryParams.pageNumber"
      :page-size="queryParams.pageSize"
      :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total"></el-pagination>
    <el-dialog center title="视频播放" width="60%" :close-on-click-modal="false" :visible.sync="showVideoDialog" @close="close()">
      <video controls autoplay width="100%" :src="videoUrl"></video>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'Log',
  data() {
    return {
      showVideoDialog: false,
      videoUrl: '',
      currentPage: 1,
      count: 15,
      // 按钮loading
      buttonLoading: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 设备日志表格数据
      logList: [],

      // 查询参数
      queryParams: {
        field101: undefined,
        pageNumber: 0,
        pageSize: 15,
        condition: {
          type: this.$route.params.type,
          deviceId: this.$route.params.deviceId,
          channelId: this.$route.params.channelId,
          startDate: undefined,
          endDate: undefined
        }
      }

    };
  },
  created() {
    this.getList();
  },
  methods: {
    goback() {
      history.back(-1)
    },
    close() {
      this.showVideoDialog = false
      this.videoUrl = ''
    },
    playRecord(row, type) {
      if (type > 0) {
        let replaceValue = "http://61.189.194.179:20000/";
        row.url=row.url.replace("http://100.127.187.50:80/","")
        this.showVideoDialog = true
        this.videoUrl = row.url
      }else{
        let replaceValue = "http://61.189.194.179:20000/";
        row.url=row.url.replace("http://100.127.187.50:80/",replaceValue)
        window.open('msplayer://url=' + row.url, '_blank')
      }
    },
    /** 查询设备日志列表 */
    getList() {
      this.loading = true;
      let that = this;
      this.$axios.post('/api/record/page', this.queryParams).then(function(res) {
        that.logList = res.data.data.content;
        that.queryParams.pageNumber = res.data.data.pageNumber;
        that.queryParams.pageSize = res.data.data.pageSize;
        //that.currentPage= res.data.data.totalPages;
        that.total = res.data.data.totalPages;
        console.log(that.currentPage, '***********')
        console.log(that.count, '***********')
        that.loading = false;
      }).catch(function(error) {
        console.log(error);
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    currentChange: function(val) {
      this.queryParams.pageNumber = val - 1;
      this.getList();
    },
    handleSizeChange: function(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deviceId: undefined,
        data: undefined,
        uploadDate: undefined,
        createTime: undefined,
        createBy: undefined,
        updateTime: undefined,
        updateBy: undefined
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.condition.startDate = this.queryParams.field101[0],
        this.queryParams.condition.endDate = this.queryParams.field101[1]
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    copyText(row, column, cell, event) {
      // 双击复制
      let save = function(e) {
        e.clipboardData.setData('text/plain', event.target.innerText);
        e.preventDefault();  //阻止默认行为
      }
      document.addEventListener('copy', save);//添加一个copy事件
      document.execCommand('copy');//执行copy方法
      this.$message({ message: '复制成功', type: 'success' })//提示
    },
    formatDate(time) {
      // time 为后端返回的格林威治时间 例：2022-06-14T09:36:41.180127
      return moment.utc(time).local().format('YYYY-MM-DD HH:mm:ss')
      // 转换后时间为: 2022-06-14 17:36:41
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/deviceCloudRecord.vue